<template>
    <div class="mask" v-show="show"></div>
    <CommonDialog class="save-dialog" v-show="show" :title="title" :size="''" @close="handleClose">
        <template v-slot:msg>
            <div class="prompt">
                <span class="dialog-message">{{ message }}</span>
                <input class="dialog-input" type="text" v-model="promptMessage" :placeholder="placeholder">
            </div>
        </template>
        <template v-slot:buttons>
            <div v-show="store.nowView != VIEW_TYPE.WEB" class="button-slot button-group">
                <div class="orange-btn save-dialog-txt dialog-btn" @click="handleExit">{{ closeTxt }}</div>
                <div class="blue-btn save-dialog-txt dialog-btn" @click="handleSave">{{ saveTxt }}</div>
                <div class="blue-btn save-dialog-txt dialog-btn" @click="handleSaveAndUpdate">{{ saveAndUpdateTxt }}</div>
            </div>
            <div v-show="store.nowView == VIEW_TYPE.WEB" class="button-slot button-group">
                <div class="blue-btn save-dialog-txt dialog-btn" @click="handleClose">{{ cancelTxt }}</div>
                <div class="blue-btn save-dialog-txt dialog-btn" @click="handleSaveAndUpdate">{{ updateTxt }}</div>
            </div>
        </template>
    </CommonDialog>
</template>

<script>
import CommonDialog from './Dialog.vue';
import SaveTool from '../../js/toolbar/save_tool';
import { store } from '../../store';
import { useUserStore } from '../../js/user_data';
import { API_GET_USER_RECORD } from '../../js/api';
import BookData from '../../js/book_data';
import AppRenderer from '@/js/app_renderer';
import { VIEW_TYPE } from '@/js/view_type';
export default {
    name: "SaveDialog",
    data: function () {
        return {
            show: false,
            title: "儲存班級紀錄",
            message: "名稱",
            saveTxt: "本機儲存",
            saveAndUpdateTxt: "本機儲存+雲端同步",
            updateTxt: "雲端儲存",
            closeTxt: "關閉電子書",
            cancelTxt: "取消",
            confirmCallback: null,
            cancelCallback: null,
            promptMessage: "",
            placeholder: "請在此輸入紀錄名稱，只允許中英數字與底線符號",
            store,
            uploadNotSupportImage: "提示! 雲端存檔不儲存圖片",
            VIEW_TYPE
        }
    },
    components: {
        CommonDialog
    },
    methods: {
        showDialog() {
            this.show = true;
        },
        handleClose() {
            this.show = false;
        },
        handleExit() {
            if (this.store.nowView == this.VIEW_TYPE.ANDROID || this.store.nowView == this.VIEW_TYPE.IOS) {
                SaveTool._instance.handleAutoSaveLocal();
            }
            AppRenderer.Instance.exit();
        },
        handleSave() {

            this.store.mergeToCloud = false;
            if (SaveTool._instance.handleNameSpaceCheck(this.promptMessage)) {
                switch (this.store.nowView) {
                    case this.VIEW_TYPE.PC:
                    case this.VIEW_TYPE.MAC:
                        SaveTool._instance.showLocalSaveDialog(this.promptMessage);
                        break;
                    case this.VIEW_TYPE.ANDROID:
                    case this.VIEW_TYPE.IOS:
                        SaveTool._instance.handleNameSpecialCheck(this.promptMessage);
                        break;
                    default:
                        console.error("存檔流程有誤")
                        break;
                }
            }
        },
        async handleSaveAndUpdate() {
            this.store.mergeToCloud = true;
            const USER_DATA = useUserStore();

            const response = await API_GET_USER_RECORD(BookData.Instance.BookId, USER_DATA.userId)
                .catch(err => {
                    console.error("error::", err);
                });

            if (!response) {
                SaveTool._instance._alertDialog.showDialog(
                    "提示",
                    "請確認網路連線狀態"
                );
                return;
            }


            if (!SaveTool._instance.handleNameSpaceCheck(this.promptMessage)) return;

            if (USER_DATA.userId.length > 0) {
                SaveTool._instance.handleNameSpecialCheck(this.promptMessage);
            } else {
                store.nowLogName = this.promptMessage;
                SaveTool._instance.handleLogin()();
            }
        },
        checkFileName(fileName) {
            SaveTool._instance.handleNameSpecialCheck(fileName);
        },
        setRecordName(recordName) {
            this.promptMessage = recordName;
        }
    }
}
</script>

<style scoped>
.save-dialog {
    z-index: var(--z-index-save-dialog);
}

.dialog-input {
    height: 1.5rem;
    width: calc(100% - 8rem);
    font-size: 1.2rem;
    margin-left: 0.5rem;
}

.dialog-input::placeholder {
    font-size: 1rem;
}

.button-slot {
    margin-bottom: 1rem;
}

.prompt {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
}

.prompt.center {
    justify-content: center;
}

.dialog-message {
    margin-left: 2.5rem;
}

.dialog-warn {
    color: red;
}

.mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #30303080;
    z-index: var(--z-index-save-dialog);
}
</style>